import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import serialsClient from "../../../../api/serials";

export type CreateClockInput = {
  serial: string;
  /** Record the serial in the test serials file; otherwise it must be in a batch. */
  testSerial: boolean;
};

const useCreateClockMutation = (
  options: UseMutationOptions<void, Error, CreateClockInput, unknown> = {},
) => {
  return useMutation({
    mutationKey: ["createClock"],
    mutationFn: async ({ serial, testSerial }: CreateClockInput) => {
      await serialsClient.createClock(serial, testSerial);
    },
    ...options,
  });
};
export default useCreateClockMutation;
